import React from 'react';
import { components, InputProps } from 'react-select';

const { Input: ReactSelectInput } = components;

function SelectInput(props: InputProps) {
  const { selectProps } = props || {};
  const { inputMode } = selectProps || {};

  return <ReactSelectInput {...props} inputMode={inputMode} />;
}

export default SelectInput;
